import IndividualTable from '../../../IndividualTable';
import { sampleData } from "../../sampleData";

const Distance145 = () => {
  let winners = ['69', '483'];
  return <IndividualTable matchType={"4"} gender="M" event="145" subTitle="Kungdo" data={sampleData} topRankCount="2" winners={winners} />;
};
export default Distance145;
